/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccordianContent } from '../../models/accordian-content';

export interface ApiMasterAccordianContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterAccordianContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterAccordianContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AccordianContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterAccordianContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccordianContent>;
    })
  );
}

apiMasterAccordianContentGetByIdGet.PATH = '/api/Master/AccordianContent/GetById';
